import { PERSISTENT_TOAST_DURATION } from './toast.const'

/** Store: schedule removeToast timeout only for finite positive durations. */
export const shouldScheduleToastDismiss = (duration?: number): boolean =>
  Number.isFinite(duration) && (duration as number) > 0

/** UI: design-system Toast still needs a duration; persistent toasts use Infinity. */
export const resolveToastViewDuration = (duration?: number): number =>
  shouldScheduleToastDismiss(duration) ? (duration as number) : PERSISTENT_TOAST_DURATION
